export default {
  'global.button.viewAll': 'View All',
  'global.button.viewAll1': 'View All',
  'global.button.cancel': 'Cancel',
  'global.button.close': 'Close',
  'global.button.add1': 'Add',
  'global.button.add': 'Add',
  'global.button.back': 'Back',
  'global.button.refresh': 'Refresh',
  'global.button.save': 'Save',
  'global.button.confirm': 'Confirm',
  'global.button.delete': 'Delete',
  'global.button.edit': 'Edit',
  'global.button.test': 'Test',
  'global.button.publish': 'Publish',
  'global.button.continues': 'Continue',
  'global.button.restore': 'Restore',
  'global.button.reject': 'Reject',
  'global.button.detail': 'Details',
  'global.button.delegatedTask': 'Delegated Tasks',
  'global.button.approved': 'Approve',
  'global.button.complete': 'Complete',
  'global.button.execution': 'Executed',
  'global.button.signature': 'Sign',
  'global.button.send': 'Send',
  'global.button.toLogin': 'Go to Login',
  'global.button.toHome': 'Go to Home',
  'global.button.enter': 'Enter',
  'global.button.ms365': 'Microsoft',
  'global.button.rememberMe': 'Remember Me',
  'global.button.copy': 'Copy',
  'global.button.reset.password': 'Reset Password',
  'global.button.sendCode': 'Send Code',
  'global.button.addForm': 'Create Form',
  'global.button.export': 'Export',
  'global.button.import': 'Import',
  'global.button.tasks': 'Tasks',
  'global.button.createRequest': 'Create Request',
  'global.button.viewDetails': 'View Details',
  'global.button.cancelRequest': 'Cancel Request',
  'global.button.completeRequestInformation': 'Complete Request Information',
  'global.button.approveRequest': 'Approve Request',
  'global.button.executeTask': 'Execute Task',
  'global.button.signDocument': 'Sign Document',
  'global.button.reassignTask': 'Reassign Task',
  'global.button.massRequestApprove': 'Approve Requests',
  'global.button.massRequestReject': 'Reject Requests',
  'global.button.initApplication': 'Initiate Request',
  'global.button.erase': 'Clear',
  'global.button.undo': 'Undo',
  'global.button.redo': 'Redo',
  'global.text.radius.brush': 'Brush Radius',
  'global.button.approve': 'Approve',
  'global.button.toFilter': 'Filter',
  'global.button.apply': 'Apply',
  'global.button.resetFilters': 'Reset Filters',
  'global.button.no': 'No',
  'global.button.yes': 'Yes',
  'global.button.signIn': 'Sign In',
  'global.button.cleanup': 'Cleanup',
  'global.button.download': 'Download',
  'global.button.print': 'Print',
  'global.button.next': 'Next',
  'global.button.previous': 'Previous',
  'global.button.google': 'Google',
  'global.button.backInAutomy': 'Enter',
  'global.button.saveAndComplete': 'Complete',
  'global.button.extraFields': 'Extra Fields',
  'global.button.sendAccountConfirmationEmail': 'Account Confirmation',
  'global.button.confirmAccount': 'Confirm Account',
  'global.button.sendPasswordRecoveryEmail': 'Recover Password',
  'global.button.resetPassword': 'Reset Password',
  'global.button.unlockAccount': 'Unlock Account',
  'global.button.setDefaultUser': 'Set as Default',
  'global.button.generate': 'Generate',
  'global.button.retry': 'Retry',
  'global.button.import': 'Import',
  'global.button.export': 'Export',
  'global.button.purge': 'Purge Data',
  'global.restore.confirmQuestion': 'Do you want to restore it?',
  'global.restore.restoreButton': 'Restore',
  // Canvas actions
  'action.config.beautify': 'Beautify',
  'action.canvas.fit': 'Fit',
  'action.canvas.center': 'Center',
  'action.canvas.reset': 'Reset',
  'action.canvas.zoomIn': 'Zoom In',
  'action.canvas.zoomOut': 'Zoom Out',
  'action.canvas.addNote': 'Add Note',
  'action.canvas.fullscreen': 'Fullscreen',
  'action.canvas.exitFullscreen': 'Exit fullscreen',
  'action.generate.ai.coming.soon': 'Generate AI (coming soon)',
  'global.button.addGroup': 'Add Group',
  'global.button.removeCondition': 'Remove Condition',
  'global.button.loadExcel': 'Load Excel',
  'global.button.company': 'Change Company',
  'global.button.environment': 'Change Environment',
  'global.button.moreDetail': 'More Details',
  'global.button.lessDetail': 'Less Details',
  'global.text.contentTooLarge': 'The content is too large to display. Please download it to view.',
  'global.button.pin': 'Send Approval PIN',
  'global.button.myDay.add': 'Add to My Day',
  'global.button.mark.important': 'Mark as Important',
  'global.button.mark.completed': 'Mark as Completed',
  'global.button.info': 'Information',
  'global.button.move': 'Move to...',
  'global.button.delete': 'Delete',
  'global.button.create.list': 'Create List',
  'global.button.accountConfirm': 'Confirm Account',
  'global.button.create': 'Create',
  'global.button.create.task': 'Create Task',
  'global.button.accountConfirm': 'Confirm Account',
  'global.button.details': 'Details',
  'global.button.editGridMode': 'Edit',
  'global.button.exitGridMode': 'Exit Edit',
  'global.button.data': 'Data',

  'global.status.sent': 'Sent',
  'global.status.sent1': 'Sent',
  'global.status.received': 'Received',
  'global.status.received1': 'Received',
  'global.status.pending': 'Pending',
  'global.status.pending1': 'Pending',
  'global.status.running': 'Running',
  'global.status.canceled': 'Canceled',
  'global.status.canceled1': 'Canceled',
  'global.status.approved': 'Approved',
  'global.status.approved1': 'Approved',
  'global.status.rejected': 'Rejected',
  'global.status.rejected1': 'Rejected',
  'global.status.voided': 'Voided',
  'global.status.voided1': 'Voided',
  'global.status.required': 'Required',
  'global.status.noRequired': 'Not Required',
  'global.status.execution': 'Execution',
  'global.status.error': 'Error',
  'global.status.processing': 'Processing',
  'global.status.processed': 'Processed',
  'global.status.processingTaskItems': 'Processing Task Items',

  'global.text.agent': 'AI Agent',
  'global.copyright': 'All rights reserved',
  'global.text.copyright': 'Copyright',
  'global.text.add': 'Add',
  'global.text.remove': 'Remove',
  'global.text.update': 'Update',
  'global.text.activate': 'Activate',
  'global.text.detail': 'Detail',
  'global.text.detail1': 'Details',
  'global.text.summary': 'Summary',
  'global.text.events': 'Events',
  'global.text.eventHistory': 'Event history',
  'global.text.eventHistory.summary': 'Delivery and tracking timeline for this email message.',
  'global.text.application': 'Request',
  'global.text.edit': 'Edit',
  'global.text.cancel': 'Cancel',
  'global.text.processes': 'Processes',
  'global.text.groups': 'Groups',
  'global.text.items': 'Items',
  'global.text.entities': 'Entities',
  'global.text.premiumEntities': 'Premium Entities',
  'global.text.premium': 'Premium',
  'global.text.basic': 'Basic',
  'global.text.showList': 'Show List',
  'global.text.viewReport': 'View Report',
  'global.text.favorites': 'Favorites',
  'global.text.list': 'List',
  'global.text.lists': 'Lists',
  'global.text.report': 'Report',
  'global.text.reports': 'Reports',
  'global.text.adminReports': 'System',
  'global.text.group': 'Group',
  'global.text.all': 'All',
  'global.text.all1': 'All',
  'global.text.advancedFilter': 'Advanced Filter',
  'global.text.hideFilter': 'Hide Filter',
  'global.text.search': 'Search',
  'global.text.filters': 'Filters',
  'global.filters.clearAll': 'Clear all',
  'global.button.remove': 'Remove',
  'configList.hero.description':
    'Configure and manage organizational {resource} used throughout the platform.',
  'configList.hero.description.readOnly':
    'View and explore organizational {resource} recorded across the platform.',
  'configList.hero.resource.areas': 'areas',
  'configList.hero.resource.positions': 'positions',
  'configList.hero.resource.customListGroups': 'list groups',
  'configList.hero.resource.dynamicEntityGroups': 'dynamic entity groups',
  'configList.hero.resource.media': 'media',
  'configList.hero.resource.mediaCategories': 'media categories',
  'configList.hero.resource.processGroups': 'process groups',
  'configList.hero.resource.connectionGroups': 'connection groups',
  'configList.hero.resource.powerBiServers': 'Power BI servers',
  'configList.hero.resource.aiAgentTeams': 'AI agent teams',
  'configList.hero.resource.aiSkillGroups': 'skill groups',
  'configList.hero.resource.userGroups': 'user groups',
  'configList.hero.resource.userDevices': 'devices',
  'configList.hero.resource.aiConsumptions': 'AI consumptions',
  'configList.hero.resource.billingSubscriptions': 'subscriptions',
  'configList.hero.resource.channelDistributors': 'distributors',
  'configList.hero.resource.channelPartners': 'partners',
  'configList.hero.resource.channelResellers': 'resellers',
  'configList.hero.resource.channelReferralAgents': 'referral agents',
  'configList.hero.resource.channelCustomerAssignments': 'customer assignments',
  'configList.hero.resource.channelAgreements': 'commercial agreements',
  'configList.hero.resource.channelPlans': 'plans',
  'configList.hero.resource.accessLog': 'access logs',
  'configList.hero.resource.accessPolicies': 'access policies',
  'configList.hero.resource.shortenedUrls': 'shortened URLs',
  'configList.hero.resource.traces': 'traces',
  'configList.hero.resource.emailMessageTraces': 'email traces',
  'configList.hero.resource.environments': 'environments',
  'configList.hero.resource.teamsMessageTraces': 'Teams message traces',
  'configList.hero.resource.smsMessageTraces': 'SMS message traces',
  'configList.hero.resource.reportGroups': 'report groups',
  'configList.hero.resource.reports': 'reports',
  'configList.hero.resource.reportTokens': 'report tokens',
  'configList.hero.resource.sequences': 'sequences',
  'configList.hero.resource.approvers': 'approvers',
  'configList.hero.resource.approversUserGroup': 'approvers by user group',
  'configList.hero.resource.approversUserGroupPosition': 'approvers by user group and position',
  'configList.hero.resource.approversUserGroupArea': 'approvers by user group and area',
  'configList.hero.resource.approversEntityUser': 'approvers by entity and user',
  'configList.hero.resource.approversEntityUserGroup': 'approvers by entity and user group',
  'configList.hero.resource.approversEntityPosition': 'approvers by entity and position',
  'configList.hero.resource.approversEntityArea': 'approvers by entity and area',
  'configList.hero.resource.emailFormats': 'email formats',
  'configList.hero.resource.extraUserFields': 'extra user fields',
  'configList.hero.resource.delegations': 'delegations',
  'configList.hero.resource.processPortal': 'process portals',
  'configList.hero.resource.users': 'users',
  'configForm.hero.summary.add': 'Provide the required information to create {resource}.',
  'configForm.hero.summary.edit': 'Update the information of the selected {resource}.',
  'configForm.hero.summary.details': 'View the information of the selected {resource}.',
  'configForm.hero.stepProgress': 'Step {current} of {total}',
  'configForm.hero.summary.resource.areas.add': 'a new area',
  'configForm.hero.summary.resource.areas.edit': 'area',
  'configForm.hero.summary.resource.areas.details': 'area',
  'configForm.hero.summary.resource.positions.add': 'a new position',
  'configForm.hero.summary.resource.positions.edit': 'position',
  'configForm.hero.summary.resource.positions.details': 'position',
  'configForm.hero.summary.resource.customListGroups.add': 'a new list group',
  'configForm.hero.summary.resource.customListGroups.edit': 'list group',
  'configForm.hero.summary.resource.customListGroups.details': 'list group',
  'configForm.hero.summary.resource.customLists.add': 'a new list',
  'configForm.hero.summary.resource.customLists.edit': 'list',
  'configForm.hero.summary.resource.customLists.details': 'list',
  'configForm.hero.summary.resource.dynamicEntityGroups.add': 'a new dynamic entity group',
  'configForm.hero.summary.resource.dynamicEntityGroups.edit': 'dynamic entity group',
  'configForm.hero.summary.resource.dynamicEntityGroups.details': 'dynamic entity group',
  'configForm.hero.summary.resource.entities.add': 'a new entity',
  'configForm.hero.summary.resource.entities.edit': 'entity',
  'configForm.hero.summary.resource.entities.details': 'entity',
  'configForm.hero.summary.resource.media.add': 'a new media item',
  'configForm.hero.summary.resource.media.edit': 'media item',
  'configForm.hero.summary.resource.media.details': 'media item',
  'configForm.hero.summary.resource.mediaCategories.add': 'a new media category',
  'configForm.hero.summary.resource.mediaCategories.edit': 'media category',
  'configForm.hero.summary.resource.mediaCategories.details': 'media category',
  'configForm.hero.summary.resource.processGroups.add': 'a new process group',
  'configForm.hero.summary.resource.processGroups.edit': 'process group',
  'configForm.hero.summary.resource.processGroups.details': 'process group',
  'configForm.hero.summary.resource.connectionGroups.add': 'a new connection group',
  'configForm.hero.summary.resource.connectionGroups.edit': 'connection group',
  'configForm.hero.summary.resource.connectionGroups.details': 'connection group',
  'configForm.hero.summary.resource.connections.add': 'a new connection',
  'configForm.hero.summary.resource.connections.edit': 'connection',
  'configForm.hero.summary.resource.connections.details': 'connection',
  'configForm.hero.summary.connections.configuration':
    'Provide the credentials and options for the {type} connection.',
  'configForm.hero.summary.resource.powerBiServers.add': 'a new Power BI server',
  'configForm.hero.summary.resource.powerBiServers.edit': 'Power BI server',
  'configForm.hero.summary.resource.powerBiServers.details': 'Power BI server',
  'configForm.hero.summary.resource.aiAgentTeams.add': 'a new AI agent team',
  'configForm.hero.summary.resource.aiAgentTeams.edit': 'AI agent team',
  'configForm.hero.summary.resource.aiAgentTeams.details': 'AI agent team',
  'configForm.hero.summary.resource.aiSkillGroups.add': 'a new skill group',
  'configForm.hero.summary.resource.aiSkillGroups.edit': 'skill group',
  'configForm.hero.summary.resource.aiSkillGroups.details': 'skill group',
  'configForm.hero.summary.resource.userGroups.add': 'a new user group',
  'configForm.hero.summary.resource.userGroups.edit': 'user group',
  'configForm.hero.summary.resource.userGroups.details': 'user group',
  'configForm.hero.summary.resource.userDevices.add': 'a new device',
  'configForm.hero.summary.resource.userDevices.edit': 'device',
  'configForm.hero.summary.resource.userDevices.details': 'device',
  'configForm.hero.summary.resource.aiConsumptions.details': 'AI consumption',
  'configForm.hero.summary.resource.billingSubscriptions.details': 'subscription',
  'configForm.hero.summary.resource.channelDistributors.details': 'distributor',
  'configForm.hero.summary.resource.channelPartners.details': 'partner',
  'configForm.hero.summary.resource.channelResellers.details': 'reseller',
  'configForm.hero.summary.resource.channelReferralAgents.details': 'referral agent',
  'configForm.hero.summary.resource.channelCustomerAssignments.details': 'customer assignment',
  'configForm.hero.summary.resource.channelAgreements.add': 'a new commercial agreement',
  'configForm.hero.summary.resource.channelAgreements.edit': 'commercial agreement',
  'configForm.hero.summary.resource.channelAgreements.details': 'commercial agreement',
  'configForm.hero.summary.resource.channelPlans.details': 'plan',
  'configForm.hero.summary.resource.accessLog.details': 'access log',
  'configForm.hero.summary.resource.accessPolicies.add': 'a new access policy',
  'configForm.hero.summary.resource.accessPolicies.edit': 'access policy',
  'configForm.hero.summary.resource.accessPolicies.details': 'access policy',
  'configForm.hero.summary.resource.shortenedUrls.details': 'shortened URL',
  'configForm.hero.summary.resource.traces.details': 'trace',
  'configForm.hero.summary.resource.emailMessageTraces.details': 'email trace',
  'configForm.hero.summary.resource.aiBillingCredits.details': 'credit grant',
  'configForm.hero.summary.resource.teamsMessageTraces.details': 'Teams message trace',
  'configForm.hero.summary.resource.smsMessageTraces.details': 'SMS message trace',
  'configForm.hero.summary.resource.environments.add': 'a new environment',
  'configForm.hero.summary.resource.environments.edit': 'environment',
  'configForm.hero.summary.resource.environments.details': 'environment',
  'configForm.hero.summary.resource.users.add': 'a new user',
  'configForm.hero.summary.resource.users.edit': 'user',
  'configForm.hero.summary.resource.users.details': 'user',
  'configForm.hero.summary.resource.reportGroups.add': 'a new report group',
  'configForm.hero.summary.resource.reportGroups.edit': 'report group',
  'configForm.hero.summary.resource.reportGroups.details': 'report group',
  'configForm.hero.summary.resource.reports.add': 'a new report',
  'configForm.hero.summary.resource.reports.edit': 'report',
  'configForm.hero.summary.resource.reports.details': 'report',
  'configForm.hero.summary.resource.reportTokens.add': 'a new report token',
  'configForm.hero.summary.resource.reportTokens.edit': 'report token',
  'configForm.hero.summary.resource.reportTokens.details': 'report token',
  'configForm.hero.summary.resource.sequences.add': 'a new sequence',
  'configForm.hero.summary.resource.sequences.edit': 'sequence',
  'configForm.hero.summary.resource.sequences.details': 'sequence',
  'configForm.hero.summary.resource.processes.add': 'a new process',
  'configForm.hero.summary.resource.processes.edit': 'process',
  'configForm.hero.summary.resource.processes.details': 'process',
  'configForm.hero.summary.resource.approversUserGroup.add': 'a new approver by user group',
  'configForm.hero.summary.resource.approversUserGroup.edit': 'approver by user group',
  'configForm.hero.summary.resource.approversUserGroup.details': 'approver by user group',
  'configForm.hero.summary.resource.approversUserGroupPosition.add':
    'a new approver by user group and position',
  'configForm.hero.summary.resource.approversUserGroupPosition.edit':
    'approver by user group and position',
  'configForm.hero.summary.resource.approversUserGroupPosition.details':
    'approver by user group and position',
  'configForm.hero.summary.resource.approversUserGroupArea.add':
    'a new approver by user group and area',
  'configForm.hero.summary.resource.approversUserGroupArea.edit': 'approver by user group and area',
  'configForm.hero.summary.resource.approversUserGroupArea.details':
    'approver by user group and area',
  'configForm.hero.summary.resource.subSequences.add': 'a new subsequence',
  'configForm.hero.summary.resource.approversEntityUser.add': 'a new approver by entity and user',
  'configForm.hero.summary.resource.approversEntityUser.edit': 'approver by entity and user',
  'configForm.hero.summary.resource.approversEntityUser.details': 'approver by entity and user',
  'configForm.hero.summary.resource.approversEntityUserGroup.add':
    'a new approver by entity and user group',
  'configForm.hero.summary.resource.approversEntityUserGroup.edit':
    'approver by entity and user group',
  'configForm.hero.summary.resource.approversEntityUserGroup.details':
    'approver by entity and user group',
  'configForm.hero.summary.resource.approversEntityPosition.add':
    'a new approver by entity and position',
  'configForm.hero.summary.resource.approversEntityPosition.edit':
    'approver by entity and position',
  'configForm.hero.summary.resource.approversEntityPosition.details':
    'approver by entity and position',
  'configForm.hero.summary.resource.approversEntityArea.add': 'a new approver by entity and area',
  'configForm.hero.summary.resource.approversEntityArea.edit': 'approver by entity and area',
  'configForm.hero.summary.resource.approversEntityArea.details': 'approver by entity and area',
  'configForm.hero.summary.resource.emailFormats.add': 'a new email format',
  'configForm.hero.summary.resource.emailFormats.edit': 'email format',
  'configForm.hero.summary.resource.emailFormats.details': 'email format',
  'configForm.hero.summary.resource.extraUserFields.add': 'a new extra user field',
  'configForm.hero.summary.resource.extraUserFields.edit': 'extra user field',
  'configForm.hero.summary.resource.extraUserFields.details': 'extra user field',
  'configForm.hero.summary.resource.delegations.add': 'a new delegation',
  'configForm.hero.summary.resource.delegations.edit': 'delegation',
  'configForm.hero.summary.resource.delegations.details': 'delegation',
  'configForm.hero.summary.resource.processPortal.add': 'a new process portal',
  'configForm.hero.summary.resource.processPortal.edit': 'process portal',
  'configForm.hero.summary.resource.processPortal.details': 'process portal',
  'configForm.hero.summary.resource.delegationConfigurations.add': 'a new configuration',
  'configForm.hero.summary.resource.delegationConfigurations.edit': 'configuration',
  'configForm.hero.summary.resource.delegationConfigurations.details': 'configuration',
  'configForm.hero.summary.resource.subSequences.edit': 'subsequence',
  'configForm.hero.summary.resource.subSequences.details': 'subsequence',
  'configForm.hero.summary.resource.reportTokenTraces.details': 'trace',
  'configForm.hero.summary.resource.internalTasks.details': 'task',
  'configInternalTasks.description': 'Monitor background export operations for this module.',
  'configInternalTasks.operationType.export': 'Export',
  'configInternalTasks.operationType.import': 'Import',
  'configInternalTasks.operationType.unknown': 'Unknown operation',
  'configInternalTasks.field.taskOutput': 'Task output',
  'configInternalTasks.field.timeZone': 'Time zone',
  'configInternalTasks.cancel.confirmContent': 'Are you sure you want to cancel this pending task?',
  'global.text.date': 'Date',
  'global.text.createdDate': 'Created Date',
  'global.smsDeliveryProvider.twilio': 'Twilio',
  'global.smsDeliveryProvider.sendblue': 'Sendblue',
  'global.sms.fromNumber': 'From number',
  'global.sms.destinationNumber': 'Destination number',
  'global.text.message': 'Message',
  'global.text.destination': 'Destination',
  'global.text.channelId': 'Channel ID',
  'global.messageStatus.queued': 'Queued',
  'global.messageStatus.processing': 'Processing',
  'global.messageStatus.sent': 'Sent',
  'global.messageStatus.error': 'Error',
  'global.messageStatus.skipped': 'Skipped',
  'global.messageStatus.failed': 'Failed',
  'global.teams.conversationDestinationType': 'Conversation destination',
  'global.teams.internalConversationReferenceId': 'Conversation reference ID',
  'global.teams.messageFormat': 'Message format',
  'global.teamsConversationDestinationType.user': 'User',
  'global.teamsConversationDestinationType.channel': 'Channel',
  'global.teamsConversationDestinationType.groupChat': 'Group chat',
  'global.teamsMessageFormat.text': 'Text',
  'global.teamsMessageFormat.markdown': 'Markdown',
  'global.teamsMessageFormat.adaptiveCard': 'Adaptive card',
  'global.text.updatedDate': 'Updated Date',
  'global.text.isPublic': 'Is Public?',
  'global.text.user': 'User',
  'global.text.system': 'System',
  'global.text.users': 'Users',
  'global.text.url': 'URL',
  'global.text.headers': 'Headers',
  'global.text.key': 'Key',
  'global.text.value': 'Value',
  'global.text.host': 'Host',
  'global.text.position': 'Position',
  'global.text.port': 'Port',
  'global.text.userGroup': 'User Group',
  'global.text.userGroups': 'User Groups',
  'global.text.userDevices': 'Devices',
  'global.text.aiConsumptions': 'AI Consumptions',
  'global.text.billingSubscriptions': 'Subscriptions',
  'global.text.channelDistributors': 'Distributors',
  'global.text.channelPartners': 'Partners',
  'global.text.channelResellers': 'Resellers',
  'global.text.channelReferralAgents': 'Referral Agents',
  'global.text.channelCustomerAssignments': 'Customer Assignments',
  'global.text.channelAgreements': 'Commercial Agreements',
  'global.text.channelPlans': 'Plans',
  'channelCustomerAssignment.columns.customerCompany': 'Customer company',
  'channelCustomerAssignment.columns.sourceType': 'Source type',
  'channelCustomerAssignment.fields.partnerId': 'Partner',
  'channelCustomerAssignment.fields.resellerId': 'Reseller',
  'channelAgreement.columns.agreementType': 'Agreement type',
  'channelAgreement.columns.approvalStatus': 'Approval status',
  'channelAgreement.columns.reviewedAt': 'Reviewed at',
  'channelAgreement.columns.ownerType': 'Ownership',
  'channelAgreement.columns.ownerDistributorId': 'Owner distributor',
  'channelAgreement.columns.payoutMode': 'Payout mode',
  'channelAgreement.columns.commissionSettlementScope': 'Settlement scope',
  'channelAgreement.fields.reviewedBy': 'Reviewed by',
  'channelAgreement.fields.reviewNotes': 'Review notes',
  'channelAgreement.ownerType.automy': 'AUTOMY',
  'channelAgreement.ownerType.distributor': 'Distributor',
  'channelAgreement.ownerType.globalAutomy': 'Global (AUTOMY)',
  'channelAgreement.ownerType.distributorPrivate': 'Distributor Private',
  'channelAgreement.approvalStatus.pendingReview': 'Pending review',
  'channelAgreement.approvalStatus.approved': 'Approved',
  'channelAgreement.approvalStatus.rejected': 'Rejected',
  'channelAgreement.payoutMode.stripeTransfer': 'Stripe transfer',
  'channelAgreement.payoutMode.manualSettlement': 'Manual settlement',
  'channelAgreement.payoutMode.none': 'None',
  'channelAgreement.commissionSettlementScope.automyManaged': 'AUTOMY Managed',
  'channelAgreement.commissionSettlementScope.externalManaged': 'External Managed',
  'channelAgreement.beneficiaryType.operator': 'Operator',
  'channelAgreement.beneficiaryType.distributor': 'Distributor',
  'channelAgreement.beneficiaryType.partner': 'Partner',
  'channelAgreement.beneficiaryType.reseller': 'Reseller',
  'channelAgreement.beneficiaryType.referralAgent': 'Referral agent',
  'channelAgreement.commissionableEventType.subscriptionInvoicePaid': 'Subscription invoice paid',
  'channelAgreement.commissionableEventType.aiCreditPurchasePaid': 'AI credit purchase paid',
  'channelAgreement.commissionableEventType.aiAutoRechargePaid': 'AI auto-recharge paid',
  'channelAgreement.commissionableEventType.aiManualCreditPurchasePaid':
    'AI manual credit purchase paid',
  'channelAgreement.calculationType.percent': 'Percent',
  'channelAgreement.calculationType.fixedAmount': 'Fixed amount',
  'channelAgreement.ruleFrequencyType.recurring': 'Recurring',
  'channelAgreement.ruleFrequencyType.oneTime': 'One-Time',
  'channelAgreement.baseAmountType.amountPaid': 'Amount paid',
  'channelAgreement.baseAmountType.planMonthlyFee': 'Plan monthly fee',
  'channelAgreement.baseAmountType.netAfterDiscountBeforeTax': 'Net before tax',
  'channelAgreement.commissionBaseType.netAmount': 'Net amount',
  'channelAgreement.commissionBaseType.netAfterProviderFees': 'Net after provider fees',
  'channelAgreement.commissionBaseType.grossAmount': 'Gross amount',
  'channelAgreement.commissionBaseType.margin': 'Margin',
  'channelAgreement.revenueType.subscription': 'Subscription',
  'channelAgreement.revenueType.creditPurchase': 'Credit purchase',
  'channelAgreement.revenueType.aiRecharge': 'AI recharge',
  'channelAgreement.revenueType.professionalServices': 'Professional services',
  'channelAgreement.revenueType.marketplace': 'Marketplace',
  'channelAgreement.revenueType.whatsAppConsumption': 'WhatsApp consumption',
  'channelAgreement.revenueType.smsConsumption': 'SMS consumption',
  'channelAgreement.revenueType.voiceConsumption': 'Voice consumption',
  'channelAgreement.revenueType.storage': 'Storage',
  'channelAgreement.revenueType.other': 'Other',
  'channelAgreement.rules.title': 'Commission rules',
  'channelAgreement.rules.summary': 'Commission rules configured for this commercial agreement.',
  'channelAgreement.rules.beneficiaryType': 'Beneficiary',
  'channelAgreement.rules.commissionableEventType': 'Commissionable event',
  'channelAgreement.rules.calculationType': 'Calculation type',
  'channelAgreement.rules.ruleFrequencyType': 'Frequency',
  'channelAgreement.rules.commissionPercent': 'Commission %',
  'channelAgreement.rules.fixedAmount': 'Fixed amount',
  'channelAgreement.rules.baseAmountType': 'Base amount',
  'channelAgreement.rules.revenueType': 'Revenue type',
  'channelAgreement.rules.commissionBaseType': 'Commission base',
  'channelAgreement.rules.mrrFrom': 'MRR from',
  'channelAgreement.rules.mrrTo': 'MRR to',
  'channelAgreement.rules.start': 'Start',
  'channelAgreement.rules.end': 'End',
  'channelAgreement.action.clone': 'Clone agreement',
  'channelPlan.columns.scope': 'Scope',
  'channelPlan.columns.kind': 'Kind',
  'channelPlan.columns.category': 'Category',
  'channelPlan.fields.tierRank': 'Tier rank',
  'channelPlan.fields.targetChannelActorKind': 'Target channel actor',
  'channelPlan.fields.exclusiveCompany': 'Exclusive company',
  'channelPlan.fields.maxRequestsCount': 'Max requests',
  'channelPlan.fields.isAzureAdEnabled': 'Azure AD enabled',
  'channelPlan.fields.isDigitalSignatureEnabled': 'Digital signature enabled',
  'channelPlan.fields.maxStorageGb': 'Max storage (GB)',
  'channelPlan.fields.monthlyOverageFee': 'Monthly overage fee',
  'channelPlan.fields.aiMonthlyIncludedCreditAmount': 'AI monthly included credit',
  'channelPlan.fields.instanceDataRetentionDays': 'Instance data retention (days)',
  'channelPlan.fields.maxEmailsCount': 'Max emails',
  'channelPlan.fields.maxIterationItemsCount': 'Max iteration items',
  'channelPlan.fields.maxBulkTaskItemsCount': 'Max bulk task items',
  'channelPlan.fields.maxEntitiesCount': 'Max entities',
  'channelPlan.fields.maxDocumentGenerationCount': 'Max document generations',
  'automyPlanScope.shared': 'Shared',
  'automyPlanScope.companyExclusive': 'Company exclusive',
  'automyPlanScope.internal': 'Internal',
  'automyPlanKind.free': 'Free',
  'automyPlanKind.trial': 'Trial',
  'automyPlanKind.paid': 'Paid',
  'automyPlanKind.custom': 'Custom',
  'automyPlanKind.internal': 'Internal',
  'automyPlanCategory.unspecified': 'Unspecified',
  'automyPlanCategory.free': 'Free',
  'automyPlanCategory.trial': 'Trial',
  'automyPlanCategory.starter': 'Starter',
  'automyPlanCategory.basic': 'Basic',
  'automyPlanCategory.business': 'Business',
  'automyPlanCategory.professional': 'Professional',
  'automyPlanCategory.enterprise': 'Enterprise',
  'automyPlanCategory.digitalTransformation': 'Digital transformation',
  'automyPlanCategory.channel': 'Channel',
  'automyPlanCategory.custom': 'Custom',
  'automyPlanCategory.internal': 'Internal',
  'channelActorKind.none': 'None',
  'channelActorKind.automyInternal': 'Automy internal',
  'channelActorKind.operator': 'Operator',
  'channelActorKind.distributor': 'Distributor',
  'channelActorKind.partner': 'Partner',
  'channelActorKind.reseller': 'Reseller',
  'channelActorKind.customer': 'Customer',
  'channelActorKind.referralAgent': 'Referral agent',
  'global.text.accessLog': 'Access Logs',
  'global.text.accessPolicies': 'Access Policies',
  'global.text.shortenedUrls': 'Shortened URLs',
  'global.text.traces': 'Traces',
  'global.text.emailMessageTraces': 'Email Traces',
  'global.text.environments': 'Environments',
  'global.text.teamsMessageTraces': 'Teams Message Traces',
  'global.text.smsMessageTraces': 'SMS Message Traces',
  'global.text.reportGroups': 'Report Groups',
  'global.text.reportTokens': 'Report Tokens',
  'global.text.sequences': 'Sequences',
  'reportGroups.title': 'Manage Report Groups',
  'global.text.config': 'Configure',
  'global.text.processConfig': 'Configure',
  'global.text.restricted': 'Restricted',
  'global.text.public': 'Public',
  'global.text.permissions': 'Permissions',
  'global.text.permissionsFiltersLogicalOperator': 'Permissions Logical Operator',
  'global.text.menu': 'Menu',
  'global.text.validated': 'Validated',
  'global.text.notValidated': 'Not Validated',
  'global.text.published': 'Published',
  'global.text.draft': 'Draft',
  'global.text.server': 'Server',
  'global.text.byPosition': 'By Position',
  'global.text.byUser': 'By User',
  'global.text.byGroup': 'By Group',
  'global.text.byArea': 'By Area',
  'global.text.userExit': 'User Exists',
  'global.text.positionExit': 'Position Exists',
  'global.text.userGroupExit': 'User Group Exists',
  'global.text.token': 'Token',
  'global.text.apiKeySecret': 'API Key Secret',
  'global.text.fromPhoneNumber': 'From phone number',
  'global.text.process': 'Process',
  'global.text.web': 'Web',
  'global.text.mobile': 'Mobile',
  'global.text.webMobile': 'Web & Mobile',
  'global.text.action': 'Action',
  'global.text.showBy': 'Show By',
  'global.text.operation': 'Operation',
  'global.text.observation': 'Observation',
  'global.text.administrator': 'Administrator',
  'global.text.superAdministrator': 'Super Administrator',
  'global.text.copying': 'Copying',
  'global.text.network.title': 'Network Exception',
  'global.text.network.info': `The connection to the server could not be established. Please check your internet connection and try again.`,
  'global.text.timeout.title': 'Request Timeout',
  'global.text.timeout.info': 'The request is taking too long. Please try again.',
  'global.text.cors.title': 'Access Restricted',
  'global.text.cors.info':
    'The operation could not be completed due to a problem communicating with the server. This may be caused by browser security restrictions or network configuration. If the problem persists, please contact support.',
  'global.text.loading': 'loading',
  'global.text.providers': 'Providers',
  'global.text.verifyCode': 'Verification Code',
  'global.text.allowedFileFormats': 'Formats',
  'global.text.startProcess': 'Start',
  'global.text.reassignTask': 'Reassign Task',
  'global.text.site': 'Portals',
  'global.text.app': 'AUTOMY',
  'global.text.start': 'Start',
  'global.text.scheduled': 'Scheduled',
  'global.text.automated': 'Automated',
  'global.text.viewDetail': 'View Detail',
  'global.text.delete': 'Delete',
  'global.text.mode': 'Mode',
  'global.text.table': 'Table',
  'global.text.property': 'Property',
  'global.text.loadingFiles': 'Loading files',
  'global.text.fallback.location': 'Default Location',
  'global.text.fileName': 'File Name',
  'global.text.pageSize': '{num} records',
  'global.text.listRecordsCount': '{count} records',
  'global.text.fields': 'Fields',
  'global.text.appClient': 'App Client',
  'global.text.engineVersion': 'Engine Version',
  'global.text.selectedElements': 'You have {count} {elements} selected',
  'global.text.elementSelected': 'element',
  'global.text.elementsSelected': 'elements',
  'global.text.selectAll': 'Select all',
  'global.text.loading': 'Loading',
  'global.text.isActive': 'Enabled',
  'global.text.favorite': 'Favorite',
  'global.text.diagram': 'Diagram',

  // Connection error messages
  'global.error.connection.noRedirectUrl': 'No redirect URL received from authorization endpoint',
  'global.error.connection.noConnectionId': 'No connection ID returned from creation',
  'global.error.connection.invalidStateFormat': 'Invalid state format - expected GUID',
  'global.error.connection.redirectedToAuthorization': 'Redirected to external authorization',

  // Password validation messages
  'global.error.password.confirmMismatch': 'Confirm password does not match',
  'global.error.password.sameAsCurrent': 'New password must be different from current password',

  // Automy AI Chat errors
  'global.error.automyAI.noResults': 'No Automy AI results found',
  'global.error.automyAI.noThreadId': 'Conversation thread ID not found',
  'global.error.automyAI.openChat': 'Error opening Automy AI conversation',

  'global.text.resource': 'Resource Type',
  'global.text.initBy': 'Started By',
  'global.text.orderBy': 'Order',
  'global.text.entity': 'Entity',
  'global.text.response': 'Response',
  'global.text.operation': 'Operation',
  'global.text.dates': 'Dates',
  'global.text.description': 'Description',
  'global.text.sp_call': 'SP Call',
  'global.text.order': 'Order',
  'global.text.title': 'Title',
  'global.text.name': 'Name',
  'global.text.details': 'Details',
  'global.text.editor': 'Editor',

  'global.text.english': 'English',
  'global.text.spanish': 'Spanish',
  'global.text.language': 'Language',

  'global.text.context.company': 'Companies',
  'global.text.context.environment': 'Environments',
  'global.text.context.user': 'My Profile',
  'global.text.context.site': 'Portals',
  'global.text.context.synced.title': 'Context updated',
  'global.text.context.synced.company':
    'You switched company in another tab. This tab now works in {name}.',
  'global.text.context.synced.environment':
    'You switched environment in another tab. This tab now works in {name}.',
  'global.text.session.ended.title': 'Session closed',
  'global.text.session.ended.description':
    'Your session was closed in another browser tab. Sign in again to continue.',

  'global.text.plan': 'Plan',
  'global.text.partner': 'Partner',
  'global.text.commercialName': 'Commercial Name',
  'global.text.noIdentity': 'Identity No.',
  'global.text.country': 'Country',
  'global.text.roles': 'Roles',
  'global.text.channel': 'Channel',
  'global.text.distributor': 'Distributor',
  'global.text.reseller': 'Reseller',

  'company.subscription.status.active': 'Active',
  'company.subscription.status.pending-activation': 'Pending activation',
  'company.subscription.status.pending-payment': 'Pending payment',
  'company.subscription.status.past-due': 'Past due',
  'company.subscription.status.suspended': 'Suspended',
  'company.subscription.status.canceled': 'Canceled',

  'company.channel.actor.none': 'No channel',
  'company.channel.actor.automy-internal': 'Automy internal',
  'company.channel.actor.operator': 'Operator',
  'company.channel.actor.distributor': 'Distributor',
  'company.channel.actor.partner': 'Partner',
  'company.channel.actor.reseller': 'Reseller',
  'company.channel.actor.customer': 'Customer',

  'company.role.owner': 'Owner',
  'company.role.admin': 'Admin',
  'company.role.billing-admin': 'Billing Admin',
  'company.role.commercial-admin': 'Commercial Admin',
  'company.role.user-admin': 'User Admin',
  'company.role.support': 'Support',
  'company.role.auditor': 'Auditor',
  'company.role.collaborator': 'Collaborator',
  'company.role.user': 'User',
  'company.role.super-admin': 'Super Admin',

  'company.plan.tag.custom': 'Custom',
  'company.plan.tag.exclusive': 'Exclusive',
  'company.plan.tag.internal': 'Internal',

  'global.text.upload.camera': 'Take a Photo',
  'global.text.upload.image': 'Click or drag an image',
  'global.text.upload.file': 'Click or drag a file',
  'global.text.upload.document': 'Click or drag a document',
  'global.text.upload.format.error':
    'Invalid file format. Please upload an Excel file (.xlsx or .xls)',
  'global.text.upload.files': 'Click or drag one or more files',
  'global.text.upload.camera.compact': 'Photo',
  'global.text.upload.image.compact': 'Image',
  'global.text.upload.file.compact': 'File',
  'global.text.upload.files.compact': 'Files',
  /* Details / view-only empty media (no action CTAs) */
  'global.text.upload.camera.emptyView': 'No photo',
  'global.text.upload.image.emptyView': 'No image',
  'global.text.upload.file.emptyView': 'No file',
  'global.text.upload.files.emptyView': 'No files',
  'global.field.signature.emptyView': 'No signature',
  'global.text.validate': 'Validate',

  'global.text.preview': 'Preview',
  'global.text.expand': 'Expand',
  'global.text.editExpanded': 'Edit Expanded',

  'vectorsUploader.subtitle.empty': 'Documents to train the agent',
  'vectorsUploader.subtitle.count': '{count} documents · {size}',
  'vectorsUploader.action.add': 'Add documents',
  'vectorsUploader.action.removeSelected': 'Remove {count} selected',
  'vectorsUploader.search.placeholder': 'Filter documents',
  'vectorsUploader.search.empty': 'No documents match "{q}"',
  'vectorsUploader.selection.selectAll': 'Select all',
  'vectorsUploader.selection.summary': '{count} selected',
  'vectorsUploader.empty.title': 'No training documents yet',
  'vectorsUploader.empty.hint': 'Add documents so the agent can use them as a knowledge base',
  'vectorsUploader.drop.title': 'Drop files here',
  'vectorsUploader.status.indexed': 'Indexed',
  'vectorsUploader.status.uploading': 'Uploading',
  'vectorsUploader.status.uploadingPct': 'Uploading · {pct}%',
  'vectorsUploader.status.error': 'Error',

  'global.created.asc': 'Created Asc',
  'global.created.desc': 'Created Desc',
  'global.text.order.short.asc': 'Created Asc',
  'global.text.order.short.desc': 'Created Desc',

  'global.text.asc': 'Asc',
  'global.text.desc': 'Desc',

  'global.empty': 'No information to show',
  'global.empty.processes': 'You have no processes to manage',
  'global.empty.source': 'You have not entered any information to display yet',
  'global.empty.pendingTasks': 'Congratulations, you have no pending tasks!',

  'global.paged.item5': '5 records',
  'global.paged.items10': '10 records',

  'global.status.active': 'Active',
  'global.status.inactive': 'Inactive',

  'global.tooltip.userGroup': 'User Group',
  'global.tooltip.userEnviroment': 'User Environments',

  'global.enable': 'Enable',
  'global.disable': 'Disable',
  'global.name': 'Name',
  'global.description': 'Description',
  'global.category': 'Category',
  'global.email': 'Email',
  'global.method': 'Method',
  'global.parameters': 'Parameters',
  'global.position': 'Position',
  'global.noData': 'No data',
  'global.authorizationType': 'Authorization Type',

  'global.enabledElement': 'Element Enabled?',
  'global.default': 'Default',
  'global.emailAddress': 'Email Address',
  'global.email.subject': 'Subject',
  'global.email.from': 'From',
  'global.email.to': 'To',
  'global.email.replyTo': 'Reply To',
  'global.email.cc': 'CC',
  'global.email.bcc': 'BCC',
  'global.email.errorMessage': 'Error Message',
  'global.email.deliveryProvider': 'Delivery provider',
  'global.email.deliveryProvider.sendgrid': 'SendGrid',
  'global.email.deliveryProvider.smtp': 'SMTP',
  'global.email.deliveryProvider.sendGrid': 'SendGrid',
  'global.email.chatThread': 'Chat Thread',
  'global.email.chatThreadId': 'Chat thread ID',
  'global.email.chatMessageId': 'Chat Message ID',
  'global.email.otherEntity': 'Other Entity',
  'global.email.otherEntityDisplayName': 'Other Entity Display Name',
  'global.email.otherEntityId': 'Other Entity ID',
  'global.email.otherEntityDisplayIdentifier': 'Other Entity Display Identifier',
  'global.email.customArgs': 'Custom Args',
  'global.email.smtpId': 'Smtp Id',
  'global.email.eventId': 'Event Id',
  'global.email.messageId': 'Message Id',
  'global.email.reason': 'Reason',
  'global.email.userAgent': 'User Agent',
  'global.email.mailEventLongDescription': 'Description',
  'global.email.mailEventLongDescription0':
    'Message has been received and is ready to be delivered',
  'global.email.mailEventLongDescription1':
    'You may see the following drop reasons: Invalid SMTPAPI header, Spam Content (if Spam Checker app is enabled), Unsubscribed Address, Bounced Address, Spam Reporting Address, Invalid, Recipient List over Package Quota',
  'global.email.mailEventLongDescription2':
    'Message has been successfully delivered to the receiving server',
  'global.email.mailEventLongDescription3':
    'Receiving server could not or would not accept mail to this recipient permanently. If a recipient has previously unsubscribed from your emails, the message is dropped',
  'global.email.mailEventLongDescription4': 'Receiving server temporarily rejected the message',
  'global.email.mailEventLongDescription5':
    'Recipient has opened the HTML message. Open Tracking needs to be enabled for this type of event',
  'global.email.mailEventLongDescription6':
    'Recipient clicked on a link within the message. Click Tracking needs to be enabled for this type of event',
  'global.email.mailEventLongDescription7':
    "Recipient clicked on the 'Opt Out of All Emails' link (available after clicking the message's subscription management link). Subscription Tracking needs to be enabled for this type of event",
  'global.email.mailEventLongDescription8':
    'The recipient re-subscribed to a specific group by updating their preferences. It is necessary to enable subscription tracking for this type of event',
  'global.email.mailEventLongDescription9': 'Recipient marked message as spam',
  'global.emailEvent.unknown': 'Unknown',
  'global.emailEvent.processed': 'Processed',
  'global.emailEvent.dropped': 'Abandoned',
  'global.emailEvent.delivered': 'Delivered',
  'global.emailEvent.bounce': 'Bounced',
  'global.emailEvent.deferred': 'Deferred',
  'global.emailEvent.open': 'Opened',
  'global.emailEvent.click': 'Clicked',
  'global.emailEvent.unsubscribe': 'Unsubscribe',
  'global.emailEvent.resubscribe': 'Resubscribe',
  'global.emailEvent.spamReport': 'Spam Report',
  'global.email.status.sent': 'Sent',
  'global.email.status.badRequest': 'Bad Request',
  'global.email.status.unauthorized': 'Unauthorized',
  'global.email.status.forbidden': 'Forbidden',
  'global.email.status.notFound': 'Not Found',
  'global.email.status.payloadTooLarge': 'Payload Too Large',
  'global.email.status.tooManyRequests': 'Too Many Requests',
  'global.email.status.internalServerError': 'Internal Server Error',
  'global.email.status.badGateway': 'Bad Gateway',
  'global.email.status.serviceUnavailable': 'Service Unavailable',
  'global.email.status.gatewayTimeout': 'Gateway Timeout',
  'global.email.status.unknown': 'Unknown',
  'global.emailType.unknown': 'Unknown',
  'global.emailType.processInstancePendingApproval': 'Request / Pending Approval',
  'global.emailType.processInstancePendingCompleteInformation':
    'Request / Pending Completion Information',
  'global.emailType.processInstancePendingTaskCompletion': 'Request / Pending Task',
  'global.emailType.processInstancePendingSignature': 'Request / Pending Signature',
  'global.emailType.processInstanceApprovalSecurityCode': 'Request / Approval Code',
  'global.emailType.processInstanceActionSendEmail': 'Request / Send Email Action',
  'global.emailType.processInstanceNewCommentNotification': 'Request / New Comment Notification',
  'global.emailType.processInstanceScheduledExecutionNotification':
    'Request / Scheduled Execution Notification',
  'global.emailType.processInstanceApprovedNotification': 'Request / Approved Notification',
  'global.emailType.processInstanceRejectedNotification': 'Request / Rejected Notification',
  'global.emailType.processInstanceCanceledNotification': 'Request / Canceled Notification',
  'global.emailType.processInstanceVoidedNotification': 'Request / Annulled Notification',
  'global.emailType.processInstanceWithErrorsNotification': 'Request / Error Notification',
  'global.emailType.userAccountConfirmation': 'User / Account Confirmation',
  'global.emailType.userAccountWelcomeMessage': 'User / Welcome Message',
  'global.emailType.userAccountResetPassword': 'User / Change Password',
  'global.emailType.userAccountTwoFactorValidationCode': 'User / Two-Factor Authentication Code',
  'global.emailType.userAccountSecurityAlertNewLogin': 'User / New Access Alert',
  'global.emailType.internalTaskErrorNotification': 'Internal Task / Error Notification',
  'global.emailType.internalTaskEntityFileReadyToDownloadNotification':
    'Internal Task / Notification Dynamic Entity File Ready to Download',
  'global.emailType.internalTaskEntityFileImportFinishNotification':
    'Internal Task / Notification Dynamic Entity Import Finished',
  'global.emailType.formFieldApiWithErrorsNotification':
    'Form API Field / API Notification with Errors',
  'global.emailType.maintenanceCompanyDeactivationNotification':
    'Maintenance / Company Deactivation Notice',
  'global.emailType.processInstanceReassigned': 'Request / Task Reassigned',
  'global.emailType.systemReportInternalTaskCompletedNotification':
    'Internal Task / Notification Completed',
  'global.emailType.taskAssigned': 'Assigned Task',
  'global.emailType.internalTaskDynamicEntityImportCompleted':
    'Internal Task / Notification Dynamic Entity Import Completed',
  'global.emailType.agentEmailMessage': 'Agent / Email Message',
  'global.emailType.internalTaskListFileReadyToDownloadNotification':
    'Internal Task / Notification Custom List File Ready for Download',
  'global.emailType.aiBillingBudgetAlertNotification': 'AI Billing / AI budget alert notification',
  'global.emailType.aiBillingMonthlyCreditGrantedNotification':
    'AI Billing / Monthly AI credit granted notification',
  'global.password': 'Password',
  'global.confirmPassword': 'Confirm Password',
  'global.order': 'Order',
  'global.executionOrder': 'Execution Order',
  'global.isPublic': 'Is Public?',

  'global.uploadFile': 'Drag and Drop a File here or Click',
  'global.enablePin': 'Enable PIN',
  'global.pinCode': 'PIN Code',
  'global.reportType': 'Report Type',
  'global.tags': 'Tags',
  'global.legend.separateWithSemicolon': 'Separate multiple {items} with a semicolon (;).',
  'global.legend.separateWithComma': 'Separate multiple {items} with a comma (,).',
  'global.legend.items.tags': 'tags',
  'global.legend.items.emails': 'emails',
  'global.legend.items.options': 'options',
  'global.legend.items.values': 'values',
  'global.platform': 'Platform',

  'global.user': 'User',
  'global.system': 'System',
  'global.key': 'Key',
  'global.value': 'Value',
  'global.type': 'Type',
  'global.title': 'Title',
  'global.databaseType': 'Database Type',

  'global.role': 'Role',
  'global.show': 'Show',
  'global.created': 'Creation Date',
  'global.updated': 'Update Date',
  'global.userCreator': 'Created By',
  'global.userModifier': 'Updated By',

  'global.of': 'of',
  'global.add': 'Add',

  'process.text.fileName': 'Name',
  'process.text.userCreator': 'Author',
  'process.text.contentType': 'File Type',
  'process.text.options': 'Options',

  'global.text.status': 'Status',
  'global.text.processGroup': 'Process Group',
  'global.text.receivedRequests': 'Received Requests',
  'global.text.myRequests': 'My Requests',
  'global.text.requestOrigin': 'Origin',

  'global.text.queries': 'Queries',
  'global.text.query': 'Query',
  'global.text.database': 'Database',

  'global.text.approved': 'Approved',
  'global.text.rejected': 'Rejected',
  'global.text.signed': 'Signed',
  'global.text.taskExecuted': 'Task Executed',
  'global.text.saved': 'Saved',
  'global.text.completed': 'Completed',
  'global.text.savedAndCompleted': 'Saved and Completed',

  'global.text.processApprovalEvaluation': 'Process Approval Evaluation',
  'global.text.delegation': 'Delegation',
  'global.text.delegationRestored': 'Delegation Restored',
  'global.text.reassignedTask': 'Reassigned Task',
  'global.text.selfAssignedTask': 'Self-assigned Task',

  'global.text.enabled': 'Enabled',
  'global.text.disabled': 'Disabled',
  'global.text.yes': 'Yes',
  'global.text.no': 'No',
  'global.text.administrador': 'Administrator',
  'global.defaults': 'Defaults',
  'global.notDefaults': 'Not Defaults',
  'global.text.criteria': 'Criteria',
  'global.text.note': 'Note',
  'global.text.none': 'None',
  'global.text.minute': 'Minutes',
  'global.text.hour': 'Hours',
  'global.text.day': 'Days',
  'global.text.month': 'Month',
  'global.text.month.january': 'January',
  'global.text.month.february': 'February',
  'global.text.month.march': 'March',
  'global.text.month.april': 'April',
  'global.text.month.may': 'May',
  'global.text.month.june': 'June',
  'global.text.month.july': 'July',
  'global.text.month.august': 'August',
  'global.text.month.september': 'September',
  'global.text.month.october': 'October',
  'global.text.month.november': 'November',
  'global.text.month.december': 'December',
  'global.text.source': 'Source',
  'global.text.businessday': 'Business day',
  'global.title.addedUsers': 'Added Users',
  'global.text.form': 'Form',
  'global.text.areas': 'Areas',
  'global.text.approvers': 'Approvers',
  'global.text.approversUserGroup': 'By Group',
  'global.text.approversUserGroupPosition': 'By Group and Position',
  'global.text.approversUserGroupArea': 'By Group and Area',
  'global.text.positions': 'Positions',
  'global.text.approversEntityUser': 'By Entity',
  'global.text.approversEntityUserGroup': 'By Entity and Group',
  'global.text.approversEntityPosition': 'By Entity and Position',
  'global.text.approversEntityArea': 'By Entity and Area',
  'global.text.customListGroups': 'List Groups',
  'global.text.dynamicEntityGroups': 'Dynamic Entity Groups',
  'global.text.media': 'Media',
  'global.text.mediaCategories': 'Media Categories',
  'global.text.emailFormats': 'Email Formats',
  'global.text.extraUserFields': 'Extra User Fields',
  'global.text.delegations': 'Delegations',
  'global.text.processPortal': 'Process Portals',
  'global.text.processGroups': 'Process Groups',
  'global.text.connectionGroups': 'Connection Groups',
  'global.text.powerBiServers': 'Power BI Servers',
  'global.text.aiAgentTeams': 'AI Agent Teams',
  'global.text.aiSkillGroups': 'Skill Groups',
  'global.text.skills': 'Skills',
  'global.text.area': 'Area',
  'global.text.areaExit': 'Area Exists',
  'global.text.itemExists': 'This item already exists in the list',
  'global.text.configuration': 'Configuration',
  'global.text.applicant': 'Applicant',
  'global.text.select': 'Select',

  'global.text.changePassword': 'Change Password',
  'global.text.twoFactor': 'Enable Two-Factor',
  'global.text.modifyView': 'Modify View',
  'global.text.logout': 'Logout',

  'global.text.company': 'Company',
  'global.text.ownerCompany': 'Owner company',
  'global.text.agreement': 'Agreement',
  'global.text.canCreateCustomers': 'Can create customers',
  'global.text.canCreatePartners': 'Can create partners',
  'global.text.canCreateResellers': 'Can create resellers',
  'global.text.canCreateReferralAgents': 'Can create referral agents',
  'global.text.partnerAgreementMode': 'Partner agreement mode',
  'global.text.defaultPartnerAgreement': 'Default partner agreement',
  'global.text.defaultResellerAgreement': 'Default reseller agreement',
  'global.text.defaultReferralAgentsAgreement': 'Default referral agent agreement',
  'global.text.identity': 'Identity',
  'global.text.shortCode': 'Short code',
  'global.text.billingResponsibility': 'Billing responsibility',
  'global.text.billingMode': 'Billing mode',
  'global.text.currency': 'Currency',
  'global.text.billingCycleType': 'Billing cycle',
  'global.text.billingCycleCount': 'Cycle count',
  'global.text.monthlyFee': 'Monthly fee',
  'global.text.paymentCollectionMode': 'Collection mode',
  'global.text.nextBillingDate': 'Next billing date',
  'global.text.autoRenew': 'Auto renew',
  'global.text.customerChannelAssignment': 'Customer assignment',
  'global.text.defaultPaymentMethod': 'Default payment method',
  'global.text.paymentTermsDays': 'Payment terms (days)',
  'global.text.currentPeriodStart': 'Current period start',
  'global.text.currentPeriodEnd': 'Current period end',
  'global.text.billingLegalName': 'Legal name',
  'global.text.billingTaxId': 'Tax ID',
  'global.text.billingEmail': 'Billing email',
  'global.text.billingCountry': 'Billing country',
  'global.text.billingAddressLine1': 'Address line 1',
  'global.text.billingAddressLine2': 'Address line 2',
  'global.text.billingCity': 'City',
  'global.text.billingState': 'State / Province',
  'global.text.billingPostalCode': 'Postal code',
  'global.text.stripeCustomerId': 'Stripe customer ID',
  'global.text.stripeSubscriptionId': 'Stripe subscription ID',
  'global.text.stripePriceId': 'Stripe price ID',
  'global.text.environment': 'Environment',

  'channelEntityStatus.active': 'Active',
  'channelEntityStatus.suspended': 'Suspended',
  'channelEntityStatus.terminated': 'Terminated',

  'channelBillingMode.stripeAutomatic': 'Stripe automatic',
  'channelBillingMode.distributorCredit': 'Distributor credit',
  'channelBillingMode.manualInvoice': 'Manual invoice',

  'channelAgreementType.distributor': 'Distributor',
  'channelAgreementType.partner': 'Partner',
  'channelAgreementType.reseller': 'Reseller',
  'channelAgreementType.referralAgent': 'Referral agent',

  'distributorPartnerAgreementMode.automyManaged': 'Automy managed',
  'distributorPartnerAgreementMode.distributorManaged': 'Distributor managed',

  'resellerBillingResponsibility.customerPaysAutomyStripe': 'Customer pays (Automy Stripe)',
  'resellerBillingResponsibility.resellerPaysAutomy': 'Reseller pays Automy',
  'resellerBillingResponsibility.manual': 'Manual',

  'billingSubscriptionStatus.pendingActivation': 'Pending activation',
  'billingSubscriptionStatus.pendingPayment': 'Pending payment',
  'billingSubscriptionStatus.active': 'Active',
  'billingSubscriptionStatus.pastDue': 'Past due',
  'billingSubscriptionStatus.canceled': 'Canceled',
  'billingSubscriptionStatus.suspended': 'Suspended',

  'billingCycleType.monthly': 'Monthly',
  'billingCycleType.quarterly': 'Quarterly',
  'billingCycleType.annual': 'Annual',

  'billingCollectionMode.automatic': 'Automatic',
  'billingCollectionMode.manual': 'Manual',

  'billingPaymentMethodType.card': 'Card',
  'billingPaymentMethodType.bankAccount': 'Bank account',
  'billingPaymentMethodType.invoice': 'Invoice',

  'customerChannelSourceType.direct': 'Direct',
  'customerChannelSourceType.partner': 'Partner',
  'customerChannelSourceType.distributor': 'Distributor',
  'customerChannelSourceType.reseller': 'Reseller',

  'currency.usd': 'USD',
  'global.text.search.company': 'Search company',
  'global.text.search.environment': 'Search environment',
  'global.text.search.site': 'Search portal',

  'global.text.skip.reason': 'Observations',
  'global.text.reject.reason': 'Rejection Reason',
  'global.text.approve.reason': 'Approval Comments',
  'global.text.complete.reason': 'Completion Comments',
  'global.text.execute.reason': 'Execution Comments',
  'global.text.cancel.reason': 'Cancellation Reason',
  'global.text.void.reason': 'Void Reason',
  'global.text.delete.reason': 'Confirm Deletion',
  'global.text.delete.description': 'Are you sure you want to delete this item?',
  'global.text.backToAction': 'Back to Action',
  'global.text.goToAction': 'Forward to Action',
  'global.text.actions': 'Actions',
  'global.text.mapSearch': 'Search on map',
  'global.text.maps.geolocate': 'Tap to center the map on your location',
  'global.text.pin.approval.reason': 'Approval PIN',

  'global.text.today': 'Today',
  'global.text.yesterday': 'Yesterday',
  'global.text.last7Days': 'Last 7 Days',
  'global.text.last15Days': 'Last 15 Days',
  'global.text.last30Days': 'Last 30 Days',
  'global.text.currentMonth': 'Current Month',
  'global.text.currentWeek': 'Current Week',
  'global.text.currentYear': 'Current Year',
  'global.text.currentDay': 'Current Day',
  'global.text.lastMonth': 'Previous Month',
  'global.text.last3Months': 'Last 3 Months',
  'global.text.last6Months': 'Last 6 Months',
  'global.text.last12Months': 'Last 12 Months',
  'global.text.customRange': 'Custom Range',

  'global.text.ongoingOps': 'Ongoing actions...',
  'global.text.ongoingOps.of': '{counter} of {count}',
  'global.text.configurations': 'Configurations',
  'global.text.void': 'Void',

  'global.error.notAccessibleCamera':
    'Camera is blocked or not accessible.\n Please allow the camera in your browser permissions and try again.',
  'global.switchCamera': 'Switch camera',
  'global.takePhoto': 'Take photo',
  'global.text.scanQr': 'Scan QR code',
  'global.qr.centerCode': 'Center the QR code within the frame',

  'global.message.processInstanceHasChanged':
    'The status of the request has changed; performing update!',
  'global.text.message.outOfBoundLocation': 'The selected location is out of the allowed area',
  'global.text.message.mockLocationProvider':
    'We have detected that you are using a simulated location. This is not allowed in our application, as it affects the accuracy of the services we offer. Please disable location simulation and try again.',
  'global.message.securityCode': 'Approval PIN code sent successfully',

  'global.attachment.type0': 'Unknown',
  'global.attachment.type1': 'Image',
  'global.attachment.type2': 'Video',
  'global.attachment.type3': 'PDF',
  'global.attachment.type4': 'Word Document',
  'global.attachment.type5': 'Spreadsheet',
  'global.attachment.type6': 'Presentation',
  'global.attachment.type7': 'Microsoft Project',
  'global.attachment.type8': 'Text',
  'global.attachment.type9': 'Xml',
  'global.attachment.type10': 'Html',
  'global.attachment.type11': 'Json',
  'global.attachment.type12': 'Zip',
  'global.attachment.type13': 'Audio',
  'global.attachment.type14': 'Rar',
  'global.attachment.type15': 'Font',
  'global.attachment.type16': 'Csv Text',

  'global.observation.type0': 'Observations',
  'global.observation.type1': 'Approval Comments',
  'global.observation.type2': 'Rejection Reason',

  'global.text.notValidFilePath': 'Cannot view file, invalid URL.',
  'global.text.unsupportedFileType': 'Cannot view file, unsupported file type.',
  'global.text.unsupportedFileTypeHint':
    'This file type cannot be previewed in the browser. You can open it in a new tab or download it.',
  'global.text.linesCount': '{count} lines',
  'global.text.filePreview.processing': 'Preparing preview…',
  'global.text.filePreview.tooLarge': 'Large file',
  'global.text.filePreview.tooLargeHint':
    'This file is too large to format here. Showing an excerpt; open or download it to view the full content.',
  'global.text.filePreview.officeTooLargeHint':
    'This file exceeds the online viewer limit (~10 MB). Open it in a new tab or download it to view the full content.',
  'global.text.filePreview.officeFailed': 'Preview could not be loaded',
  'global.text.filePreview.officeFailedHint':
    'The viewer did not respond in time. You can retry, open the file in a new tab, or download it.',
  'global.text.filePreview.officeUnreachableHint':
    'The file could not be reached (the URL may have expired). Open it in a new tab or download it; if it persists, re-upload the file.',
  'global.text.filePreview.officeOpeningExcel': 'Opening with Excel for the web…',
  'global.text.filePreview.officeOpeningWord': 'Opening with Word for the web…',
  'global.text.filePreview.officeOpeningPowerPoint': 'Opening with PowerPoint for the web…',
  'global.text.filePreview.officeOpening': 'Opening with Office for the web…',
  'global.text.filePreview.officeLoadingDocument': 'Loading document…',
  'global.text.filePreview.officeSlowHint': 'This is taking longer than usual.',
  'global.text.filePreview.officeMoreOptions': 'More options',
  'global.button.openNewTab': 'Open in a new tab',
  'global.text.form.placeholder': 'Please fill in all required fields',
  'global.text.importConfirm': 'Do you want to delete existing data?',

  'global.text.error.geolocation.failed': 'Error: Geolocation service failed.',
  'global.text.error.geolocation.support': 'Error: Your browser does not support Geolocation.',
  'global.text.error.geolocation.denied': 'Error: Location access denied.',
  'global.text.error.video.support': 'Video format not supported.',
  'global.text.error.audio.support': 'Audio format not supported.',

  'global.error.title': 'Error',
  'global.error.404.title': 'Page Not Found',
  'global.error.403.subTitle': 'Insufficient permissions. User does not have required permissions.',
  'global.error.404.subTitle': "Looks like you're trying to find your way home",
  'global.error.default': 'The specified application is no longer available',
  'global.error.unknown': 'An unexpected error occurred. Please try again.',

  'global.planType0': 'Trial',
  'global.planType1': 'Partner',
  'global.planType2': 'Basic',
  'global.planType3': 'Business',
  'global.planType4': 'Enterprise',
  'global.planType5': 'Customized',

  'global.displayText': 'Display Text',
  'global.internalName': 'Internal Name',

  'global.field.text': 'Text',
  'global.field.textMultiple': 'Multiple Text',
  'global.field.int': 'Integer',
  'global.field.int32': 'Integer',
  'global.field.decimal': 'Decimal',
  'global.field.boolean': 'Boolean',
  'global.field.dateTime': 'Date and Time',
  'global.field.date': 'Date',
  'global.field.time': 'Time',
  'global.field.choice': 'Selection',
  'global.field.dataBaseRemoteSearch': 'Database Remote Search',
  'global.field.dataBaseRemoteList': 'Database Remote List',
  'global.field.webServiceRemoteSearch': 'Web Service Remote Search',
  'global.field.webServiceRemoteList': 'Web Service Remote List',
  'global.field.databaseRemoteSearch': 'Database Remote Search',
  'global.field.databaseRemoteList': 'Database Remote List',
  'global.field.webserviceRemoteSearch': 'Web Service Remote Search',
  'global.field.webserviceRemoteList': 'Web Service Remote List',

  'global.field.selectorUser': 'User Selector',
  'global.field.selectorPosition': 'Position Selector',
  'global.field.selectorUserGroup': 'User Group Selector',
  'global.field.table': 'Table',
  'global.field.attachment': 'Attachment',
  'global.field.file': 'File',
  'global.field.autoCalculatedByTableColumn': 'Calculated by Table',
  'global.field.fieldDynamicEntityList': 'Entity List',
  'global.field.calculatedByFormula': 'Calculated by Formula',
  'global.field.image': 'Image',
  'global.field.photo': 'Photo',
  'global.field.signature': 'Signature',
  'global.field.goToAction': 'Go to Action',
  'global.field.slider': 'Slider',
  'global.field.fieldDynamicEntitySearch': 'Entity Search',
  'global.field.selectorArea': 'Area Selector',
  'global.field.radioGroup': 'Radio Group',
  'global.field.checkGroup': 'Check Group',
  'global.field.url': 'URL',
  'global.field.or': 'OR',
  'global.field.and': 'AND',
  'global.field.location': 'Location',
  'global.field.internalEntity': 'Internal Entity',
  'global.field.yesNo': 'Yes/No',
  'global.field.intNumber': 'Integer Number',
  'global.field.decimalNumber': 'Decimal Number',
  'global.field.email': 'Email',
  'global.field.password': 'Password',
  'global.text.dragDrop': 'Drag and drop or click to replace',
  'global.text.deleteData': 'Delete existing data',
  'global.text.selectFile': 'Please select a file',
  'global.button.loadFile': 'Load File',
  'global.text.auditor': 'Auditor',
  'global.text.collaborator': 'Collaborator',
  'global.text.userManager': 'User Manager',
  'global.text.content': 'Content',
  'global.error.import.data': 'Row {rowNumber}: {errorMessage}',
  'global.error.import.multiple':
    'Found {errorCount} errors in the import. Review the details below.',
  'global.error.import.detailed':
    'Found {errorCount} errors in {rowsWithErrors} rows. {originalMessage}',
  'global.text.support': 'Support',
  'global.text.row': 'Row',
  'global.text.column': 'Column',
  'global.text.id': 'ID',
  'global.text.field': 'Field',
  'global.text.error': 'Error',
  'global.text.warning': 'Heads up',
  'global.text.information': 'Information',
  'global.text.validate': 'Validate',

  'global.field.ascending': 'Ascending',
  'global.field.descending': 'Descending',
  'global.field.none': 'None',
  'global.field.value': 'Value',
  'global.field.displayText': 'Display Text',
  'global.field.development': 'Development',
  'global.field.testing': 'Testing',
  'global.field.production': 'Production',

  'global.text.columnOrderDirection.ascending': 'Ascending',
  'global.text.columnOrderDirection.descending': 'Descending',
  'global.text.responseGroupingType.none': 'None',
  'global.text.responseGroupingType.value': 'Value',
  'global.text.responseGroupingType.displayText': 'Display Text',

  // User Role translations
  'global.role.RoleAdmin': 'Administrator',
  'global.role.RoleSuperAdmin': 'Super Administrator',
  'global.role.RoleSupport': 'Support',
  'global.role.RoleUser': 'User',
  'global.role.RoleCollaborator': 'Collaborator',
  'global.role.RoleAuditor': 'Auditor',
  'global.role.RoleUserManager': 'User Manager',
  'global.role.RolePartner': 'Partner',
  'global.role.admin': 'Administrator',
  'global.role.super-admin': 'Super Administrator',
  'global.role.support': 'Support',
  'global.role.user': 'User',
  'global.role.collaborator': 'Collaborator',
  'global.role.auditor': 'Auditor',
  'global.role.user-admin': 'User Manager',
  'global.role.partner': 'Partner',

  // RoleName enum translations (global)
  'roleName.engine': 'Engine',
  'roleName.apiServer': 'API Server',
  'roleName.chatApiServer': 'Chat API Server',
  'roleName.dataApiServer': 'Data API Server',
  'roleName.externalSystemProvider': 'External System Provider',
  'roleName.automyAgent': 'Automy Agent',
  'roleName.externalUser': 'External User',
  'roleName.automyProcessPortal': 'Automy Process Portal',
  'roleName.automyApp': 'Automy App',
  'roleName.superAdmin': 'Super Administrator',
  'roleName.owner': 'Owner',
  'roleName.admin': 'Administrator',
  'roleName.billingAdmin': 'Billing Administrator',
  'roleName.commercialAdmin': 'Commercial Administrator',
  'roleName.userAdmin': 'User Manager',
  'roleName.support': 'Support',
  'roleName.auditor': 'Auditor',
  'roleName.partner': 'Partner',
  'roleName.collaborator': 'Collaborator',
  'roleName.user': 'User',

  'global.profile.photo.upload.success': 'Profile photo updated successfully',
  'global.profile.photo.upload.error': 'Error updating profile photo',

  // Global bulk delete translations - can be reused by any module
  'global.bulk.delete.success':
    '{successCount} {successElement} {eliminated} of {total} {totalElement}. {errorCount} {errorElement} could not be deleted.',
  'global.bulk.delete.error.only': '{errorCount} {errorElement} could not be deleted.',
  'global.bulk.delete.errors.title': 'Delete Errors',
  'global.errors.title': 'Errors',
  'global.import.errors.title': 'Import Errors',
  'global.import.result.title': 'Import result',
  'global.bulk.delete.eliminated.singular': 'was deleted',
  'global.bulk.delete.eliminated.plural': 'were deleted',
  'global.bulk.delete.element.singular': 'element',
  'global.bulk.delete.element.plural': 'elements',
  'global.bulk.delete.could.not.be.deleted.singular': 'could not be deleted',
  'global.bulk.delete.could.not.be.deleted.plural': 'could not be deleted',

  // Generic image messages for reusable components
  'global.image.upload.title': 'Upload image',
  'global.image.change.title': 'Change image',
  'global.image.upload.no.file': 'Please select an image first',
  'global.image.upload.error': 'Error processing image',
  'global.image.upload.invalid.type': 'You can only upload image files',
  'global.image.upload.invalid.size': 'Image must be smaller than 5MB',
  'global.image.upload.formats': 'PNG, JPG, GIF up to 5MB',
  'global.image.rotate.left': 'Rotate left',
  'global.image.rotate.right': 'Rotate right',
  'global.image.drag.instruction': 'Drag the image to adjust the preview',
  'global.image.select.different': 'Select different image',

  // Date formats
  'global.date.format': 'MM/DD/YYYY',

  // HTTP Response Status Codes
  'global.httpResponseStatusCode.100': 'Continue',
  'global.httpResponseStatusCode.101': 'Switching Protocols',
  'global.httpResponseStatusCode.200': 'OK',
  'global.httpResponseStatusCode.201': 'Created',
  'global.httpResponseStatusCode.202': 'Accepted',
  'global.httpResponseStatusCode.203': 'Non-Authoritative Information',
  'global.httpResponseStatusCode.204': 'No Content',
  'global.httpResponseStatusCode.205': 'Reset Content',
  'global.httpResponseStatusCode.206': 'Partial Content',
  'global.httpResponseStatusCode.300': 'Multiple Choices',
  'global.httpResponseStatusCode.301': 'Moved Permanently',
  'global.httpResponseStatusCode.302': 'Found',
  'global.httpResponseStatusCode.303': 'See Other',
  'global.httpResponseStatusCode.304': 'Not Modified',
  'global.httpResponseStatusCode.305': 'Use Proxy',
  'global.httpResponseStatusCode.306': 'Unused',
  'global.httpResponseStatusCode.307': 'Temporary Redirect',
  'global.httpResponseStatusCode.400': 'Bad Request',
  'global.httpResponseStatusCode.401': 'Unauthorized',
  'global.httpResponseStatusCode.402': 'Payment Required',
  'global.httpResponseStatusCode.403': 'Forbidden',
  'global.httpResponseStatusCode.404': 'Not Found',
  'global.httpResponseStatusCode.405': 'Method Not Allowed',
  'global.httpResponseStatusCode.406': 'Not Acceptable',
  'global.httpResponseStatusCode.407': 'Proxy Authentication Required',
  'global.httpResponseStatusCode.408': 'Request Timeout',
  'global.httpResponseStatusCode.409': 'Conflict',
  'global.httpResponseStatusCode.410': 'Gone',
  'global.httpResponseStatusCode.411': 'Length Required',
  'global.httpResponseStatusCode.412': 'Precondition Failed',
  'global.httpResponseStatusCode.413': 'Request Entity Too Large',
  'global.httpResponseStatusCode.414': 'Request-URI Too Long',
  'global.httpResponseStatusCode.415': 'Unsupported Media Type',
  'global.httpResponseStatusCode.416': 'Requested Range Not Satisfiable',
  'global.httpResponseStatusCode.417': 'Expectation Failed',
  'global.httpResponseStatusCode.426': 'Upgrade Required',
  'global.httpResponseStatusCode.500': 'Internal Server Error',
  'global.httpResponseStatusCode.501': 'Not Implemented',
  'global.httpResponseStatusCode.502': 'Bad Gateway',
  'global.httpResponseStatusCode.503': 'Service Unavailable',
  'global.httpResponseStatusCode.504': 'Gateway Timeout',
  'global.httpResponseStatusCode.505': 'HTTP Version Not Supported',

  // RunCode Operation Status
  'global.runCodeOperationStatus.1': 'Pending',
  'global.runCodeOperationStatus.2': 'Installing',
  'global.runCodeOperationStatus.3': 'Running',
  'global.runCodeOperationStatus.4': 'Completed',
  'global.runCodeOperationStatus.5': 'Failed',
  'global.runCodeOperationStatus.6': 'Expired',
  'global.runCodeOperationStatus.7': 'Error',
  'global.runCodeOperationStatus.8': 'Not Found',

  // Process Config
  'process.config.version': 'Version',
  'process.config.versionSelectorDisabled': 'Version selector coming soon',

  'global.text.column.extraSmall': 'Extra Small',
  'global.text.column.small': 'Small',
  'global.text.column.medium': 'Medium',
  'global.text.column.large': 'Large',

  'global.dynamicEntityVersionOperation.1': 'Generate Token ReadOnly',
  'global.dynamicEntityVersionOperation.2': 'Generate Token Write',
  'global.dynamicEntityVersionOperation.3': 'Append Component',
  'global.dynamicEntityVersionOperation.4': 'Modify Component',
  'global.dynamicEntityVersionOperation.5': 'Remove Component',
  'global.dynamicEntityVersionOperation.6': 'Publish',
  'global.dynamicEntityVersionOperation.7': 'New Version Created',

  'global.userDisplayValue.full-name': 'Full Name',
  'global.userDisplayValue.email': 'Email',
  'global.userDisplayValue.extra-field': 'Extra Field',
  'global.userDisplayValue.position': 'Position',
  'global.userDisplayValue.area': 'Area',

  'global.internalTaskStatus.type1': 'Pending',
  'global.internalTaskStatus.type2': 'Processing',
  'global.internalTaskStatus.type3': 'Processed',
  'global.internalTaskStatus.type4': 'Error',
  'global.internalTaskStatus.type5': 'Skipped',
  'global.internalTaskStatus.type6': 'Cancelled',
  'global.internalTaskStatus.type7': 'Failed',
  'global.internalTaskStatus.type8': 'Paused',

  // Clipbord
  'global.clipboard.copied': 'Copied to clipboard',
  'global.clipboard.error': 'Clipboard copy error',

  'actions.type.default': 'Process action',
  'actions.type.defaultInitial': 'Default Initial',
  'actions.type.completeInformation': 'Complete Information',
  'actions.type.approval': 'Approval',
  'actions.type.autoApprove': 'Automatic Approval',
  'actions.type.conditional': 'Conditional',
  'actions.type.executeTask': 'Execute Task',
  'actions.type.executeApiCall': 'Execute API Call',
  'actions.type.autoReject': 'Automatic Rejection',
  'actions.type.digitalSignature': 'Digital Signature',
  'actions.type.sendEmail': 'Send Email',
  'actions.type.executeQuery': 'Execute Database Query',
  'actions.type.dynamicEntityOperation': 'Operation on Dynamic Entity',
  'actions.type.generateExcel': 'Generate Excel',
  'actions.type.startProcessInstance': 'Start Process',
  'actions.type.setVariableData': 'Set Variable',
  'actions.type.setFormData': 'Set Form Data',
  'actions.type.parallel': 'Parallel',
  'actions.type.generateDocuments': 'Generate Documents',
  'actions.type.scheduledExecution': 'Scheduled Execution',
  'actions.type.sharePointOperation': 'SharePoint Operation',
  'actions.type.iterate': 'Iterate / Apply to Each',
  'actions.type.switch': 'Switch',
  'actions.type.internalOperation': 'Internal Operation',
  'actions.type.generatePlainTextFile': 'Generate Text File',
  'actions.type.importPlainTextFile': 'Import Plain Text File',
  'actions.type.consumeSequence': 'Consume Sequence',
  'actions.type.executeRpaFlow': 'Execute RPA Flow',
  'actions.type.integration': 'Integration',
  'actions.type.autoCancel': 'Automatic Cancel',
  'actions.type.autoVoid': 'Automatic Annulment',
  'actions.type.openAi': 'Open AI',
  'actions.type.executeProcessAction': 'Execute Process Action',
  'actions.type.googleIntegration': 'Google Integration',
  'actions.type.revertCancellation': 'Revert Cancellation',
  'actions.type.revertVoiding': 'Revert Voiding',
  'actions.type.ftpOperation': 'FTP Operation',
  'actions.type.runCode': 'Run Code',
  'actions.type.automyAi': 'Automy AI',
  'actions.type.whatsAppBusinessIntegration': 'WhatsApp Business Integration',
  'actions.type.microsoftTeamsIntegration': 'Microsoft Teams Integration',

  'accessPolicy.effect.allow': 'Allow',
  'accessPolicy.effect.deny': 'Deny',

  'global.text.number': 'Number',
  'global.text.operationType': 'Operation Type',
  'global.text.observations': 'Observations',
  'global.text.processingDate': 'Processing Date',
  'global.text.processedDate': 'Processed Date',
  'global.text.processingAttempts': 'Processing Attempts',
  'global.text.scheduledDate': 'Scheduled Date',
  'global.text.taskParameters': 'Task parameters',
  'global.text.alertEmails': 'Alert emails',
  'global.text.lastProcessingHeartbeat': 'Last processing heartbeat',
  'global.text.processingNodeId': 'Processing node ID',
  'global.text.processingNodeName': 'Processing node name',
  'global.text.importance': 'Importance',
  'global.text.dependsOnTaskNumber': 'Depends-on task',

  'internalTaskStatus.pending': 'Pending',
  'internalTaskStatus.processing': 'Processing',
  'internalTaskStatus.processed': 'Processed',
  'internalTaskStatus.error': 'Error',
  'internalTaskStatus.skipped': 'Skipped',
  'internalTaskStatus.cancelled': 'Cancelled',
  'internalTaskStatus.failed': 'Failed',
  'internalTaskStatus.paused': 'Paused',
  'internalTaskStatus.unknown': 'Unknown',
  'config.info.createdBy': 'Created by',
  'config.info.updatedBy': 'Modified by',
  'config.info.creationDate': 'Creation date',
  'config.info.formId': 'Form ID',
  'config.info.processId': 'Process ID',
  'config.publish.notAvailable': 'Publishing is not available yet',
};
